// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"414":"cockpit","594":"about"}[chunkId] || chunkId) + "." + {"399":"861b44da","414":"35f79de8","594":"90c0629f","869":"c733bc7d"}[chunkId] + ".js";
};